/**
 * Route for `custom-postback-domain`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomPostbackDomainPage } from "../features/custom-postback-domain/CustomPostbackDomainPage";

export const customPostbackDomainRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-postback-domain",
	component: CustomPostbackDomainPage,
});

export default customPostbackDomainRoute;
